// Mock data para Adriana Calero Seguridad Contra Incendios

export const companyInfo = {
  name: "Adriana Calero Seguridad Contra Incendios",
  tagline: "Protegiendo vidas y patrimonio desde 2010",
  phone: "+34 900 123 456",
  email: "contacto@adrianacalero.com",
  address: "Calle Principal 123, Madrid, España",
  socialMedia: {
    facebook: "#",
    instagram: "#",
    linkedin: "#"
  }
};

export const services = [
  {
    id: 1,
    title: "Venta de Extintores",
    description: "Amplia gama de extintores para todo tipo de necesidades y clasificaciones de fuego.",
    icon: "flame"
  },
  {
    id: 2,
    title: "Mantenimiento e Inspecciones",
    description: "Servicio técnico especializado en mantenimiento preventivo y correctivo de equipos contra incendios.",
    icon: "wrench"
  },
  {
    id: 3,
    title: "Capacitación y Entrenamiento",
    description: "Cursos en prevención de incendios, uso de extintores y evacuación de emergencia.",
    icon: "graduationCap"
  },
  {
    id: 4,
    title: "Instalación de Sistemas",
    description: "Diseño e instalación de sistemas completos de detección y extinción de incendios.",
    icon: "settings"
  },
  {
    id: 5,
    title: "Asesoría en Seguridad",
    description: "Evaluación de riesgos y planes de emergencia personalizados para su empresa.",
    icon: "clipboardCheck"
  },
  {
    id: 6,
    title: "Recarga de Extintores",
    description: "Servicio rápido de recarga de extintores de todos los tipos.",
    icon: "rotateCw"
  }
];

export const productCategories = [
  {
    id: "extintores",
    name: "Extintores",
    description: "Equipos para todo tipo de fuego"
  },
  {
    id: "equipos",
    name: "Equipos de Protección",
    description: "Equipamiento profesional"
  },
  {
    id: "senalizacion",
    name: "Señalización",
    description: "Señales de emergencia y evacuación"
  },
  {
    id: "deteccion",
    name: "Incendios",
    description: "Equipos diseñados para el control eficiente de incendios, garantizando respuesta rápida y máxima seguridad en situaciones de emergencia."
  },
  {
    id: "Seguridad Vial",
    name: "Seguridad Vial",
    description: "Equipos diseñados para el control eficiente de incendios, garantizando respuesta rápida y máxima seguridad en situaciones de emergencia."
  }
];

export const products = [
  // Extintores
   {
    id: 1,
    category: "extintores",
    name: "Extintor Tipo BC",
    description: "Extintor de polvo químico seco eficaz contra fuegos de líquidos inflamables y equipos eléctricos.",
    fireTypes: "B, C",
    agent: "Polvo químico seco",
    capacity: "5 lbs - 10 lbs - 15 lbs -20 lbs - 30 lbs - 100 lbs",
    certification: "NTC 2885",
    advantages: "No conduce electricidad, apaga rápidamente líquidos inflamables",
    disadvantages: "Deja residuos que pueden dañar equipos",
    image: "/extintores1.jpeg"
  },
  {
    id: 2,
    category: "extintores",
    name: "Extintor Tipo ABC",
    description: "Extintor multipropósito que combate fuegos de materiales sólidos, líquidos inflamables y equipos eléctricos.",
    fireTypes: "A, B, C",
    agent: "Polvo químico seco (fosfato monoamónico)",
    capacity: "5 lbs - 10 lbs - 20 lbs - 30 lbs - 150 lbs",
    certification: "NTC 2885",
    advantages: "Versátil, ideal para hogares, oficinas y vehículos",
    disadvantages: "Deja residuos",
    image: "/extintores2.jpg"
  },
  {
    id: 3,
    category: "extintores",
    name: "Extintor CO2",
    description: "Extintor de dióxido de carbono ideal para equipos eléctricos y electrónicos, no deja residuos.",
    fireTypes: "B, C",
    agent: "Dióxido de carbono (CO2)",
    capacity: "5 lbs - 10 lbs - 15 lbs - 20 lbs - 50 lbs - 100 lbs",
    certification: "NTC 2885",
    advantages: "No deja residuos, seguro para equipos electrónicos",
    disadvantages: "Menor alcance y efectividad en espacios abiertos",
    image: "/extintores3.jpg"
  },
  {
    id: 4,
    category: "extintores",
    name: "Extintor Clase K",
    description: "Especial para fuegos en aceites y grasas de cocinas comerciales, evita la reignición.",
    fireTypes: "K",
    agent: "Acetato de potasio",
    capacity: "1.5 gls - 2.5 gls",
    certification: "NTC 2885",
    advantages: "Ideal para cocinas industriales, alta efectividad en grasas",
    disadvantages: "Uso específico (no multipropósito)",
    image: "/extintores4.jpg"
  },
  {
    id: 5,
    category: "extintores",
    name: "Extintor Agua a Presión",
    description: "Extintor de agua a presión para fuegos de materiales sólidos como madera, papel y textiles.",
    fireTypes: "A",
    agent: "Agua a presión",
    capacity: "2.5 gls - 18 gls",
    certification: "NTC 2885",
    advantages: "Económico, fácil de usar",
    disadvantages: "No usar en electricidad ni líquidos inflamables",
    image: "/extintores5.jpg"
  },
// EQUIPOS DE PROTECCIÓN
  {
    id: 6,
    category: "equipos",
    name: "Cascos",
    description: "Casco de seguridad industrial resistente a impactos.",
    features: "Protección contra impactos",
    certification: "EN 397",
    image: "/proteccion1.jpg"
  },
  {
    id: 7,
    category: "equipos",
    name: "Chalecos",
    description: "Chaleco de alta visibilidad con bandas reflectivas.",
    features: "Alta visibilidad",
    certification: "EN 20471",
    image: "/proteccion2.jpg"
  },
  {
    id: 8,
    category: "equipos",
    name: "Gafas de Seguridad",
    description: "Protección ocular para trabajos industriales.",
    features: "Antiempañantes",
    certification: "EN 166",
    image: "/proteccion3.jpg"
  },
  {
    id: 9,
    category: "equipos",
    name: "Guantes de Protección",
    description: "Guantes resistentes para trabajos exigentes.",
    features: "Resistencia a cortes",
    certification: "EN 388",
    image: "/proteccion4.jpg"
  },
   {
    id: 10,
    category: "equipos",
    name: "Tapa Oídos",
    description: "Protección auditiva diseñada para reducir altos niveles de ruido en entornos industriales.",
    features: "Alta reducción de ruido y ajuste cómodo",
    certification: "EN 352",
    image: "/proteccion5.jpg"
  },
   {
    id: 11,
    category: "equipos",
    name: "Gabinete Contra Incendio",
    description: "Gabinete metálico diseñado para almacenar mangueras y equipos contra incendio.",
    features: "Alta resistencia y fácil acceso",
    certification: "Norma NFPA",
    image: "/proteccion7.jpg"
  },

  // SEÑALIZACIÓN
  {
    id: 12,
    category: "senalizacion",
    name: "Señal de Incendios",
    description: "Señal fotoluminiscente de alta visibilidad.",
    size: "30x15 cm",
    certification: "ISO 7010",
    image: "/señalizacion.jpg"
  },
  {
    id: 11,
    category: "senalizacion",
    name: "Lamparas de Emergencia",
    description: "Indicador de ubicación de extintor.",
    size: "21x30 cm",
    certification: "ISO 7010",
    image: "/señalizacion1.jpg"
  },
    {
    id: 13,
    category: "senalizacion",
    name: "Brazaletes",
    description: "Señal fotoluminiscente de alta visibilidad.",
    size: "30x15 cm",
    certification: "ISO 7010",
    image: "/señalizacion2.jpg"
  },

  // Sistemas de Detección
  {
    id: 14,
    category: "deteccion",
    name: "Boquillas",
    description: "Controlan el flujo y tipo de chorro de agua.",
    features: "Chorro regulable",
    certification: "NFPA",
    image: "/incendios1.jpg"
  },
  {
    id: 15,
    category: "deteccion",
    name: "Mangueras",
    description: "Transportan agua a alta presión para apagar incendios.",
    features: "Alta resistencia",
    certification: "NFPA",
    image: "/incendios2.jpg"
  },
 {
  id: 16,
  category: "Seguridad Vial",
  name: "Paletas Pare y Siga",
  description: "Elemento de señalización vial para control seguro del tránsito en diferentes entornos.",
  features: "Alta visibilidad",
  certification: "Calidad Garantizada",
  image: "/seguridad.jpg"
},
{
  id: 17,
  category: "Seguridad Vial",
  name: "Botiquines",
  description: "Kit de primeros auxilios con implementos básicos para atención inmediata en emergencias.",
  features: "Uso práctico",
  certification: "Calidad Garantizada",
  image: "/seguridad1.jpg"
},
{
  id: 18,
  category: "Seguridad Vial",
  name: "Camilla Rígida",
  description: "Camilla de apoyo para inmovilización y traslado seguro de personas lesionadas.",
  features: "Alta resistencia",
  certification: "Calidad Garantizada",
  image: "/seguridad2.jpg"
},
{
  id: 19,
  category: "Seguridad Vial",
  name: "Inmovilizadores",
  description: "Elementos diseñados para brindar soporte y estabilidad en la atención de emergencias.",
  features: "Seguridad y soporte",
  certification: "Calidad Garantizada",
  image: "/seguridad3.jpg"
},
{
  id: 20,
  category: "Seguridad Vial",
  name: "Conos",
  description: "Dispositivos de señalización para delimitar zonas y prevenir riesgos en vías y espacios de trabajo.",
  features: "Alta visibilidad",
  certification: "Calidad Garantizada",
  image: "/seguridad4.jpg"
},
{
  id: 21,
  category: "Seguridad Vial",
  name: "Kit de Carretera",
  description: "Conjunto de elementos esenciales para asistencia y prevención en carretera.",
  features: "Equipo completo",
  certification: "Calidad Garantizada",
  image: "/seguridad5.jpg"
},
{
  id: 22,
  category: "Seguridad Vial",
  name: "Kit de Control de Derrame",
  description: "Kit especializado para contener, absorber y manejar derrames de forma segura.",
  features: "Respuesta rápida",
  certification: "Calidad Garantizada",
  image: "/seguridad6.jpg"
},
];

export const galleryImages = [
  {
    id: 1,
    title: "Instalaciónes",
    category: "proyectos",
    image: "/instalaciones.png"
  },
  {
    id: 2,
    title: "Capacitación Empresarial",
    category: "capacitaciones",
    image: "/capacitaciones.png"
  },
  {
    id: 3,
    title: "Mantenimientos",
    category: "servicios",
    image: "/mantenimiento.png"
  },

  {
    id: 5,
    title: "Inspección de Seguridad",
    category: "servicios",
    image: "/inspecciones.png"
  },
  {
    id: 6,
    title: "Equipos de Protección",
    category: "proyectos",
    image: "/equipos.png"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Carlos Martínez",
    company: "Industrias del Norte S.A.",
    text: "Excelente servicio. El equipo de Adriana Calero realizó una inspección completa y nos ayudó a cumplir con todas las normativas.",
    rating: 5
  },
  {
    id: 2,
    name: "Laura Sánchez",
    company: "Hotel Plaza Real",
    text: "Profesionales, puntuales y muy bien preparados. Las capacitaciones fueron excelentes.",
    rating: 5
  },
  {
    id: 3,
    name: "Miguel Ángel Torres",
    company: "Restaurante El Fogón",
    text: "Instalaron nuestro sistema completo de seguridad. Muy recomendables, precios justos y trabajo impecable.",
    rating: 5
  }
];
